export const US = "US";
export const UK = "UK";
export const PAYPAL_CREDIT_MAX_LIMIT_FOR_UK = 20000.0;
export const PAYPAL_CREDIT_MAX_LIMIT_FOR_US = 12000.0;
export const APR_RATE = 29.24;
export const APR_DATE = "3/1/2024";
export const TGR_BUTTION_LINK_ID = 7476;
export const PAYPAL_APPLY_LINK_ID = 7478;
export const PAYPAL_FAQ_LINK_ID = 7477;
export const ukInitMinMonthlyPayment = "min-monthly" + "\n" + "payment";
export const PAYPAL_CREDIT_PROD_URL_US =
  "https://www.paypal.com/ppcreditapply/da/us?actor=ebay&catsId=DA_AD_EBAY&return_uri=https://www.ebay.com";
export const PAYPAL_CREDIT_PROD_URL_UK =
  "https://www.paypal.com/ppcreditapply/da/gb?actor=ebay&catsId=DA_AD_EBAY&return_uri=https://www.ebay.co.uk";
export const PAYPAL_CREDIT_QA_URL_US =
  "https://www.ebayqe.stage.paypal.com/ppcreditapply?flow_type=directapp&actor=EBAY&return_uri=https://www.ebay.com";
export const PAYPAL_CREDIT_QA_URL_UK =
  "https://www.ebayqe.stage.paypal.com/ppcreditapply/da/gb?actor=eBay&return_uri=https://www.ebay.co.uk";
export const COOKIE_PERSISTENT_ACCOUNT_ID = 156;
export const EBAY_BUCKS_REDIRECT_URL =
  "https://www.ebay.com/help/buying/paying-items/earning-using-ebay-bucks?id=4638";
export const EBAY_NECTAR_REDIRECT_URL = "https://pages.ebay.co.uk/pnsctrieahyb";
